import React from 'react'
import BreadCrumb from '../../../../components/Breadcrumb'
import { AutoComplete } from 'primereact/autocomplete'
import { Dropdown } from 'primereact/dropdown'
import { Formik } from 'formik'
import moment from 'moment/moment'
import { Paginator } from 'primereact/paginator'
import { Button } from 'primereact/button'
import queryString from 'query-string'
import { Link } from 'react-router-dom'
import Router from '../../../../routes/router'

const DETAILS_OPTIONS = [
  { label: '申請', value: '申請' },
  { label: '再申請', value: '再申請' },
  { label: '1次チェック', value: '1次チェック' },
  { label: '承認', value: '承認' },
  { label: '再提出依頼', value: '再提出依頼' },
  { label: '許可（直接操作）', value: '許可（直接操作）' },
  { label: '制限（直接操作）', value: '制限（直接操作）' },
]

const ActivityLogsCarCommutingUpdateByStaffScene = ({
                                                      i18n, staffs, doctors,onSearch, edges,  staffId,
                                                      page, count, onPageChange, rowsPerPage,  doctorId, details
                                                    }) => {
  return (
    <React.Fragment>
      {/*header*/}
      <div className='staff-header'>
        <div className='staff-title'>
          マイカー通勤申請・承認履歴
          <BreadCrumb
            items={[{ title: 'マイカー通勤申請・承認履歴' }]}
          />
        </div>
      </div>

      {/*body*/}
      <div className='container'>
        <div className='box'>
          {/*search form*/}
          <Formik
            initialValues={{
              staff: staffs.find(staff => staff.id === staffId),
              doctor: doctors.find(doctor => doctor.id === doctorId),
              details: details || null,
              staffs,
              doctors,
            }}
            onSubmit={() => {}}
            render={formikProps => {
              const { values, setFieldValue } = formikProps
              return (<div style={{display: 'flex', gap: '20px'}}>
                <div>
                  <AutoComplete
                    {...formikProps}
                    value={values.staff}
                    suggestions={values.staffs}
                    completeMethod={e => {
                      const results = staffs.filter(
                        staff =>
                          staff.fullName
                            .toLowerCase()
                            .includes(e.query.toLowerCase()) ||
                          staff.fullNameKana
                            .toLowerCase()
                            .includes(e.query.toLowerCase()) ||
                          staff.email
                            .toLowerCase()
                            .includes(e.query.toLowerCase())
                      )
                      setFieldValue('staffs', results)
                    }}
                    minLength={1}
                    placeholder='操作者をお選びください'
                    field='fullNameEmail'
                    onUnselect={() => onSearch({ staff: null, doctor: values.doctor, details: values.details })}
                    onSelect={e => onSearch({ staff: e.value, doctor: values.doctor, details: values.details })}
                    onChange={(e)=>{
                      setFieldValue('staff', e.value)
                    }
                  }
                    dropdown
                    style={{ minWidth: '300px' }}
                  />
                </div>
                <div>
                  <AutoComplete
                    {...formikProps}
                    value={values.doctor}
                    suggestions={values.doctors}
                    completeMethod={e => {
                      const results = doctors.filter(
                        doctor =>
                          doctor.fullName
                            .toLowerCase()
                            .includes(e.query.toLowerCase()) ||
                          doctor.fullNameKana
                            .toLowerCase()
                            .includes(e.query.toLowerCase()) ||
                          doctor.email
                            .toLowerCase()
                            .includes(e.query.toLowerCase())
                      )
                      setFieldValue('doctors', results)
                    }}
                    minLength={1}
                    placeholder='対象の医師をお選びください'
                    field='fullNameEmail'
                    onUnselect={() => onSearch({ staff: values.staff, doctor: null, details: values.details })}
                    onSelect={e => onSearch({ doctor: e.value, staff: values.staff, details: values.details })}
                    onChange={(e) =>{
                      setFieldValue('doctor', e.value)
                      }
                    }
                    dropdown
                    style={{ minWidth: '300px' }}
                  />
                </div>
                <div>
                  <Dropdown
                    value={values.details}
                    options={DETAILS_OPTIONS}
                    onChange={e => {
                      setFieldValue('details', e.value)
                      onSearch({ staff: values.staff, doctor: values.doctor, details: e.value })
                    }}
                    placeholder='対応内容をお選びください'
                    showClear
                    style={{ minWidth: '300px' }}
                  />
                </div>
                <div>
                  {
                    (values.staff || values.doctor || values.details) && (<Link
                      to={{
                        pathname: Router.staffActivityLogsCarCommutingListUpdateByStaff,
                        search: queryString.stringify({
                          rowsPerPage,
                        }),
                      }}
                    >
                      <Button
                        icon='pi pi-times'
                        className='p-button-secondary'
                        style={{ marginLeft: '20px' }}
                      />
                    </Link>)
                  }
                </div>
              </div>)
            }}
          />
          {/*data*/}
          <div style={{marginTop: '15px'}}>
            <table className='table' style={{ width: '100%' }}>
              <thead>
              <tr>
                <th>
                  操作者区分
                </th>
                <th>
                  操作者名
                </th>
                <th>
                  医師名
                </th>
                <th>
                  対応内容
                </th>
                <th>
                  操作日時
                </th>
              </tr>
              </thead>
              <tbody>
              {
                edges.map(({ node }) => (
                  <tr key={node.id}>
                    <td>{node.staff ? 'スタッフ ' : 'ドクター'}</td>
                    <td>{
                      node.staff
                        ? `${node.staff.lastname} ${node.staff.firstname}`
                        : `${node.doctor.lastname} ${node.doctor.firstname}`
                    }</td>
                    <td>{node.doctor ? `${node.doctor.lastname} ${node.doctor.firstname}` : ''}</td>
                    <td>{node.details ?? ''}</td>
                    <td className='center'>
                      {moment(node.createdAt).format('LLL (dd)')}
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </table>
          </div>
          {/*paginate*/}
          <Paginator
            rows={rowsPerPage}
            totalRecords={count}
            first={(page - 1) * rowsPerPage}
            onPageChange={onPageChange}
            leftContent={
              <div className='paginator-total'>
                {i18n.t('main.paginationTotal')}: {count}
              </div>
            }
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default ActivityLogsCarCommutingUpdateByStaffScene
